const Flag = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ minWidth: '41px', minHeight: '20px' }}
            width="41"
            height="20"
            viewBox="0 0 41 20"
            fill="none"
        >
            <path d="M4.2915 1.66406V18.3307V1.66406Z" fill="#747474" />
            <path
                d="M4.2915 1.66406V18.3307"
                stroke="#747474"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.2915 3.33594H13.6248C15.8748 3.33594 16.3748 4.58594 14.7915 6.16927L13.7915 7.16927C13.1248 7.83594 13.1248 8.91927 13.7915 9.5026L14.7915 10.5026C16.3748 12.0859 15.7915 13.3359 13.6248 13.3359H4.2915"
                stroke="#747474"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line x1="40.5" y1="2.5" x2="40.5" y2="17.5" stroke="#D9D9D9" />
        </svg>
    );
};

export default Flag;
